import script from "./UploadMixin2.vue?vue&type=script&lang=js"
export * from "./UploadMixin2.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__